import PropTypes from 'prop-types';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from 'contexts/AuthContext';
import Loader from './Loader';

const ERP_ROLES = ['manager', 'planner', 'operator'];
const normalizeRole = (value) => (ERP_ROLES.includes(value) ? value : 'operator');

export default function RoleGuard({ roles = [], children }) {
  const { loading, erpRole } = useAuth();
  const location = useLocation();

  if (loading) {
    return <Loader />;
  }

  const currentRole = normalizeRole(erpRole);
  const allowedRoles = Array.isArray(roles) ? roles : [];

  if (allowedRoles.length > 0 && !allowedRoles.includes(currentRole)) {
    return <Navigate to="/erp/quick-start" state={{ from: location }} replace />;
  }

  return children;
}

RoleGuard.propTypes = {
  roles: PropTypes.arrayOf(PropTypes.string),
  children: PropTypes.node
};
